document.addEventListener('DOMContentLoaded', () => {
    console.log('Initializing video playback logic...');
    const slider = document.querySelector('.t4s-slideshow'); // Ensure this targets the correct container
    if (slider) {
        console.log('Slider found:', slider);
        
        // Get all slides inside the slider
        const slides = slider.querySelectorAll('.t4s-slide');

        // Function to handle video playback for visible and hidden slides
        const updateVideoPlayback = () => {
            slides.forEach((slide) => {
                const video = slide.querySelector('video');
                if (video) {
                    const isVisible = !slide.hasAttribute('aria-hidden');
                    if (isVisible) {
                        console.log('Playing video for visible slide:', slide);
                        video.play().catch((error) => {
                            console.error('Error playing video:', error);
                        });
                    } else {
                        console.log('Pausing video for hidden slide:', slide);
                        video.pause();
                        video.currentTime = 0; // Optional: Reset time
                    }
                }
            });
        };

        // Initial check on page load
        updateVideoPlayback();

        // Observe changes in aria-hidden attributes
        const observer = new MutationObserver(() => {
            console.log('Slide visibility changed. Updating video playback...');
            updateVideoPlayback();
        });

        observer.observe(slider, { attributes: true, subtree: true });
    } else {
        console.error('Slider not found.');
    }
});
